import React, { useState } from 'react';
import { RadioGroup, Box, Typography } from '@mui/material';
import SubmitButton from '../common/SubmitButton';
import Radio from '../Base/Radio/index';
import BasicRadio from '../Base/BasicRadio';
import Note from '../common/Note';
const EnachRadios = () => {
  const [show, setShow] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const handleChange = (e) => {
    setDisabled(false);
    let value = e.target.value;
    if (value && value === 'digitalMandate') {
      setShow(true);
    } else {
      setShow(false);
    }
  };
  return (
    <>
      <form id="enach">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            mb: 20,
          }}
        >
          <RadioGroup name="enach" onChange={handleChange}>
            <Radio
              align="flex-center"
              value="netbanking"
              label="Net Banking or Credit Card"
            />
            <Radio
              align="flex-start"
              value="digitalMandate"
              label="Digital Mandate (e-NACH)"
              component={
                <>
                  {show && (
                    <RadioGroup name="digitalMandate">
                      <BasicRadio
                        label="Net banking or debit card"
                        value="netBanking"
                      />
                      <BasicRadio
                        label="Sign-in with Aadhaar OTP"
                        value="aadharOTP"
                      />
                    </RadioGroup>
                  )}
                </>
              }
            />
          </RadioGroup>
          {show && (
            <Note note="Use savings account as primary option to create digital mandate" />
          )}
        </Box>
      </form>
      <SubmitButton disabled={disabled} form="enach" hasNote={'No'} />
    </>
  );
};

export default EnachRadios;
